import { render, staticRenderFns } from "./addAdvertisement.vue?vue&type=template&id=2ab3de26&scoped=true&"
import script from "./addAdvertisement.vue?vue&type=script&lang=js&"
export * from "./addAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./addAdvertisement.vue?vue&type=style&index=0&id=2ab3de26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3de26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab3de26')) {
      api.createRecord('2ab3de26', component.options)
    } else {
      api.reload('2ab3de26', component.options)
    }
    module.hot.accept("./addAdvertisement.vue?vue&type=template&id=2ab3de26&scoped=true&", function () {
      api.rerender('2ab3de26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addAdvertisement.vue"
export default component.exports